import { getDate } from '@systemeio/components'

type DatePickerMinDateStrategy = 'date-picker' | 'date-range-picker'

export function getDatePickerMinDate(
  createdAt?: string,
  timezone?: string,
  minDate?: Date,
  strategy: DatePickerMinDateStrategy = 'date-picker',
) {
  const createdAtMinDate = createdAt && timezone ? getDate(createdAt, timezone) : undefined

  if (!minDate) {
    return createdAtMinDate
  }

  if (strategy === 'date-range-picker' && createdAtMinDate && createdAtMinDate > minDate) {
    return createdAtMinDate
  }

  return minDate
}
